import React, { useEffect, useState   } from "react";
import { Card, Col, Row, Table, Badge } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import { getUserTasks } from "../../services/UserServices/UserService";
import PageTitle from "../layouts/PageTitle";
export default function Task() {

    const [tasks,setTasks]=useState([]);
   const { id1, id2 } = useParams();   
 
const location = useLocation();
  const historyData = location.state?.history;
 
     useEffect(() => {
    const getTasks =async()=>{
      try {
           const res = await getUserTasks(id1,id2);
              
             
              setTasks(res?.data?.data);
              
      } catch (error) {
          console.error(error?.response?.data?.message);
      }
    }
       if(id1){
      getTasks();
   }
     }, []);
 

  return (
    <div className="qx-page">

        <PageTitle
          motherMenu="User List"
          activeMenu={`${historyData?.user?.hostName}  >${historyData?.event?.name?.name} > Task List`}
        />

      <Row>
        <Col>
          <Card className="qx-table-card">
            <Card.Body>
              <Table responsive bordered className="table-black-border" >
                <thead style={{ color: "#A60000"}}>
                  <tr>
                    <th ><strong>S.NO</strong></th>
                    <th><strong>Task Name</strong></th>
                    <th><strong>Event Name</strong></th>
                    <th><strong>Assigned To</strong></th>
                    <th><strong>Priority</strong></th>
                    <th><strong>Due Date</strong></th>
                                     
                    <th><strong>Status</strong></th>
  
                  </tr>
                </thead>
                <tbody>
                  {tasks?.map((task, index) => (
                    <tr style={{ color: "#A60000" }} key={index}>
                      <td>{index + 1}</td>
                      <td>{task.name}</td>
                      <td>{task?.event.name.name}</td>
                      <td>{task?.assigningTo ? task?.assigningTo?.hostName : "Not Assigned"}</td>
                      <td>
                        {task.priority.toLowerCase() === "high" && (
                          <Badge bg="danger">{task.priority.charAt(0).toUpperCase() + task.priority.slice(1).toLowerCase()}</Badge>
                        )}
                        {task.priority.toLowerCase() === "medium" && (
                          <Badge bg="warning">{task.priority.charAt(0).toUpperCase() + task.priority.slice(1).toLowerCase()}</Badge>
                        )}
                        {task.priority.toLowerCase() === "low" && (
                          <Badge bg="info">{task.priority.charAt(0).toUpperCase() + task.priority.slice(1).toLowerCase()}</Badge>
                        )}
                      </td>
                      <td>  {new Date(task?.dueDate).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}</td>
     
                      <td>
                        {task?.status.toLowerCase() === "upcoming" ? (
                       <Badge bg="secondary">{task.status.charAt(0).toUpperCase() + task.status.slice(1).toLowerCase()} </Badge>
                        ) : (
                                                    <Badge bg="success">{task?.status}</Badge>
                   
                        )}
                      </td>
                              
                    </tr>
                  ))}
                </tbody>
              </Table>

              {tasks.length === 0 && (
                <div className="justify-content-center d-flex my-5">
                  No Tasks Found!
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}









 